import { render, staticRenderFns } from "./CustomMealDealSet.vue?vue&type=template&id=1c04d02a&scoped=true&"
import script from "./CustomMealDealSet.vue?vue&type=script&lang=js&"
export * from "./CustomMealDealSet.vue?vue&type=script&lang=js&"
import style0 from "./CustomMealDealSet.vue?vue&type=style&index=0&id=1c04d02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04d02a",
  null
  
)

export default component.exports